import React from 'react';
import {FadeIn} from '../../components/ui/FadeIn';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiUsers,FiVideo,FiBookOpen,FiCheck}=FiIcons;

const CorporateLearning=()=> {
  return (
    <div className="pt-20 pb-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeIn className="text-center mb-16">
        <h1 className="text-4xl md:text-6xl font-black mb-6 text-white drop-shadow-[0_2px_20px_rgba(255,255,255,0.2)]">
          Transform your webinar library into a training catalog
        </h1>
        <p className="text-xl text-white/80 max-w-3xl mx-auto drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]">
          Extract structured training modules from hundreds of unused Zoom recordings. No new budget required.
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20">
        <FadeIn delay={0.1} className="glass-card p-8 text-center border-2 border-brand-electric/30">
          <SafeIcon icon={FiVideo} className="text-5xl text-brand-electric mx-auto mb-4" />
          <div className="text-4xl font-black text-brand-electric mb-2 drop-shadow-[0_0_15px_rgba(0,229,255,0.5)]">340+</div>
          <p className="text-white/70 text-sm">Hours of unused video recordings in the average company</p>
        </FadeIn>

        <FadeIn delay={0.2} className="glass-card p-8 text-center border-2 border-brand-flame/30">
          <SafeIcon icon={FiBookOpen} className="text-5xl text-brand-flame mx-auto mb-4" />
          <div className="text-4xl font-black text-brand-flame mb-2 drop-shadow-[0_0_15px_rgba(255,51,102,0.5)]">$5k-$15k</div>
          <p className="text-white/70 text-sm">Cost of manual course creation per hour of content</p>
        </FadeIn>

        <FadeIn delay={0.3} className="glass-card p-8 text-center border-2 border-brand-mint/40 shadow-[0_0_20px_rgba(16,185,129,0.2)]">
          <SafeIcon icon={FiUsers} className="text-5xl text-brand-mint mx-auto mb-4" />
          <div className="text-4xl font-black text-brand-mint mb-2 drop-shadow-[0_0_15px_rgba(16,185,129,0.5)]">&lt;$5</div>
          <p className="text-white/70 text-sm">Cost to transform 1 hour of video with VidRevive</p>
        </FadeIn>
      </div>

      {/* Use Cases */}
      <FadeIn className="mb-16">
        <h3 className="text-3xl font-bold text-center mb-10 text-white">Perfect For Corporate L&D Teams</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="glass-card p-8 border border-white/10">
            <h4 className="text-xl font-bold text-brand-electric mb-4">Onboarding Programs</h4>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Convert orientation videos into structured modules</span>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Create downloadable resources for new hires</span>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Standardize training across departments</span>
              </li>
            </ul>
          </div>

          <div className="glass-card p-8 border border-white/10">
            <h4 className="text-xl font-bold text-brand-electric mb-4">Compliance Training</h4>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Transform policy webinars into courses</span>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Generate certificates and completion tracking</span>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Update content quickly when regulations change</span>
              </li>
            </ul>
          </div>

          <div className="glass-card p-8 border border-white/10">
            <h4 className="text-xl font-bold text-brand-electric mb-4">Sales Enablement</h4>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Turn product demos into training materials</span>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Create pitch decks from recorded calls</span>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Scale best practices across teams</span>
              </li>
            </ul>
          </div>

          <div className="glass-card p-8 border border-white/10">
            <h4 className="text-xl font-bold text-brand-electric mb-4">Leadership Development</h4>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Package executive talks into courses</span>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Preserve institutional knowledge</span>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiCheck} className="text-brand-electric shrink-0 mt-1" />
                <span>Build management training libraries</span>
              </li>
            </ul>
          </div>
        </div>
      </FadeIn>

      <FadeIn className="text-center mb-12">
        <h3 className="text-2xl font-bold mb-8 text-white">Seamless LMS Integrations</h3>
        <div className="flex flex-wrap justify-center gap-4 text-white/80">
          {['Workday','TalentLMS','SAP SuccessFactors','Docebo','Cornerstone'].map(lms=> (
            <span key={lms} className="glass-card px-6 py-3 rounded-full text-sm font-medium border-2 border-brand-border/50 hover:border-brand-electric/40 transition-colors">{lms}</span>
          ))}
        </div>
      </FadeIn>

      {/* CTA */}
      <FadeIn className="text-center">
        <button className="btn-cta py-4 px-12 text-lg mb-3 text-brand-neon">
          Start Free
        </button>
        <p className="text-sm text-white/60">No credit card required</p>
      </FadeIn>
    </div>
  );
};

export default CorporateLearning;